<template>
    <div class="totalizadores">
        <v-card
            v-for="item in itens"
            :key="item.label"
            outlined
            class="tot-card"
            :class="{ 'tot-destaque': item.destaque }"
        >
            <div class="text-caption grey--text text-truncate">{{ item.label }}</div>

            <div class="tot-valor" :class="item.cor ? `${item.cor}--text` : ''">
                <v-progress-circular v-if="loading" indeterminate size="16" width="2" color="grey"/>
                <template v-else>{{ item.valor }}</template>
            </div>

            <div v-if="item.detalhe && !loading" class="text-caption grey--text text-truncate">
                {{ item.detalhe }}
            </div>
        </v-card>
    </div>
</template>

<script>
export default {
    name: 'Totalizadores',

    props: {
        itens: {
            type: Array,
            default: () => [],
        },

        loading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.totalizadores {
    display: flex;
    gap: 8px;
    overflow-x: auto;
    padding: 4px 2px 2px 2px;
}

.tot-card {
    flex: 1 0 auto;
    min-width: 132px;
    padding: 8px 12px;
    border-radius: 8px;
}

.tot-destaque {
    border-width: 2px;
}

.tot-valor {
    font-size: 1.05rem;
    font-weight: 600;
    line-height: 1.5rem;
    white-space: nowrap;
}
</style>
